module.exports = __webpack_public_path__ + "img/monaco.5019ec53.svg";